import { render } from "./interactions.vue?vue&type=template&id=109005c8"
import script from "./interactions.js?vue&type=script&lang=js"
export * from "./interactions.js?vue&type=script&lang=js"

import exportComponent from "/woodpecker/src/akkoma.dev/AkkomaGang/akkoma-fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__